module.exports = __webpack_public_path__ + "media/images/crm/content-illustration-2-9ea518ad73327e7e448d02bde2f0a8fa.png";